'use client';

import { StoryblokReactComponent } from '@/storyblok/components/componentsMap';
import { BlogFaqStoryblok, PostFaqItemStoryblok } from '@/storyblok/types';
import { makeRichTextRenderOptions } from '@/storyblok/utils/richText';
import { ChevronUpIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { useRef, useState } from 'react';
import { render } from 'storyblok-rich-text-react-renderer';

export const BlogFAQItem: StoryblokReactComponent<PostFaqItemStoryblok> = ({ story, component }) => {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  const richTextRenderOptions = makeRichTextRenderOptions(story);

  return (
    <div className="border-b border-primary/15 px-5 last:border-b-0 sm:px-6 md:px-7">
      <button
        onClick={() => setIsOpen(prevState => !prevState)}
        className="flex w-full items-center justify-between gap-2 py-4 text-left text-sm font-semibold text-neutral-darker sm:py-5 sm:text-base"
      >
        <h3>{component.question}</h3>
        <ChevronUpIcon className={clsx('size-4 stroke-2 transition-transform', isOpen ? 'rotate-0' : '-rotate-180')} />
      </button>

      <div
        ref={contentRef}
        className="overflow-hidden transition-all ease-in-out"
        style={{ maxHeight: isOpen ? `${contentRef.current?.scrollHeight}px` : '0px' }}
      >
        <div className="pb-5 pt-0 text-sm leading-relaxed text-neutral-lighter">{render(component.answer, richTextRenderOptions)}</div>
      </div>
    </div>
  );
};

const BlogFAQ: StoryblokReactComponent<BlogFaqStoryblok> = ({ story, component }) => {
  return (
    <div className="rounded-2xl border border-primary/15">
      {component.items.length > 0 && (
        <div className="relative w-full" data-orientation="vertical">
          {component.items.map(item => (
            <BlogFAQItem key={item._uid} story={story} component={item} />
          ))}
        </div>
      )}
    </div>
  );
};

export default BlogFAQ;
